/* eslint-disable camelcase */
import APIClient from '@/shared/http/clients/api'

const resourceName = 'board'
const APICore = process.env.APIBaseURLCore

const Board_GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const Board_GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?arquivado=false&sort=name,asc&size=500`, data, config)
const Board_GetAllByTipoBoard = (tipoBoard) => APIClient.get(`${APICore}/${resourceName}/?tipoBoard=${tipoBoard}&size=500`)
const Board_GetAllNotFromModular = () => APIClient.get(`${APICore}/${resourceName}/?notFromModular=true&sort=name,asc&size=500`)
const Board_GetAllByPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const Board_GetById = (boardId, config = {}) => APIClient.get(`${APICore}/${resourceName}/${boardId}`, config)
const Board_GetAllProducts = (boardId, config = {}) => APIClient.get(`${APICore}/${resourceName}/${boardId}/produtos`, config)
const Board_GetReport = (boardId, config = {}) => APIClient.get(`${APICore}/${resourceName}/${boardId}/report`, config)
const Board_Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Board_Update = (boardId, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${boardId}`, data, config)
const Board_Delete = (boardId, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${boardId}`, config)
const Board_Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?descricao=${document}&page=${index}&size=${limit}`, config)

const BoardRepository = {
  Board_GetAll,
  Board_GetAllActive,
  Board_GetAllByTipoBoard,
  Board_GetAllNotFromModular,
  Board_GetAllByPaging,
  Board_GetById,
  Board_GetAllProducts,
  Board_GetReport,
  Board_Create,
  Board_Update,
  Board_Delete,
  Board_Search
}

export default BoardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/board.js